import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appClickOutside]'
})
export class ClickOutsideDirective {

  constructor(private elementRef: ElementRef) { }

  @Output() appClickOutside = new EventEmitter<MouseEvent>();

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
      if (!targetElement) {
          return;
      }
      const clickedInside = this.elementRef.nativeElement.contains(targetElement);
      // console.log(" this.elementRef.nativeElement", this.elementRef.nativeElement)
      // console.log(" targetElement", targetElement)
      // console.log("  event.target.classList",  targetElement.classList)
      var hasClass :any= Array.from( targetElement.classList);//.indexOf('mat-calendar') > -1

//console.log("hasClass",hasClass)
let _cal=false;
hasClass.map((x)=>{
 // console.log("x.toLowerCase()",x.toLowerCase())
  if(x.toLowerCase().includes('mat-calendar') && !_cal){
    _cal=true;
  }
  if(x.toLowerCase().includes('mrc_sle_view') && !_cal){
    _cal=true;
  }
  if(x.toLowerCase().includes('txts') && !_cal){
    _cal=true;
  }
  if(x.toLowerCase().includes('txtsa') && !_cal){
    _cal=true;
  }
  
})

     // console.log("_cal",_cal)
      if (!clickedInside && !_cal) {
          this.appClickOutside.emit(event);
      }
  }

}
